export default {
  "content": "<path d=\"M11 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h6v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM20 21a1 1 0 01-1 1h-2v-2h1v-7h2v8zM19 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM21.207 3.207l-7.5 7.5-1.414-1.414 7.5-7.5 1.414 1.414zM14.5 1.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};